import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Typography, Paper, CircularProgress, Box } from '@mui/material';
import API from '@utils/axios';
import Layout from '@components/Layout';
import PageError from '@components/PageError';
import Form from '@components/Form';
function ButtonPage() {
    const { t } = useTranslation();
    const { key } = useParams();

    const [loading, setLoading] = useState(true);
    const [errorCode, setErrorCode] = useState(null);
    const [actionData, setActionData] = useState(null);
    const [confirmed, setConfirmed] = useState(false);

    const formatData = (definition, data) => {
        const formattedData = {};
        definition.fields.forEach(field => {
            if (field.type === 'date') {
                // Pour les objets de type date, on formatte en 'aaaa-mm-dd'
                formattedData[field.name] = (data[field.name] instanceof Date ? data[field.name].toISOString().split('T')[0] : data[field.name]) || '';
            } else if (field.type !== 'info') {
                formattedData[field.name] = data[field.name] || '';
            }
        });
        return formattedData;
    }

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await API.post(`/actions/${key}`, formatData(actionData.formDefinition, data));
            if (response.status === 200 && response.data.success) {
                setConfirmed(true);
            } else {
                setErrorCode('confirm_error');
            }
        } catch (err) {
            console.error('Error:', err);
            setErrorCode('confirm_internal_error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchAction = async () => {
            try {
                const { data } = await API.get(`/actions/${key}`);
                if (data.actionType !== 'contact-button' && data.actionType !== 'contact-sms') {
                    setErrorCode('invalid_action_type');
                    return;
                }
                if (!data.form) {
                    setErrorCode('action_without_form');
                    return;
                }
                setActionData(data);
            } catch (err) {
                if (err.response?.status === 404) {
                    setErrorCode(err.response.data.code);
                } else {
                    setErrorCode('internal_error');
                    console.error('Error:', err);
                }
            } finally {
                setLoading(false);
            }
        };

        if (key) {
            fetchAction();
        }
    }, [key]);

    return errorCode ? (
        <PageError
            title={t('Page not found')}
            message={t('This link is invalid or expired.')}
            message2={t('Error code: {{code}}', { code: errorCode })}
        />
    ) : (
        loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: '20vh' }} >
                <CircularProgress />
            </Box >
        ) : (
            confirmed ? (
                <Layout customer={actionData.customer} size="md" title={t('Data saved')} >
                    <Paper sx={{ p: 3 }}>
                        <Typography variant="h2" sx={{ mb: 2 }}>{t('Data saved')}</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{t('Your answers have been saved. Thank you for your action.')}</Typography>
                    </Paper>
                </Layout>
            ) : (
                <Layout customer={actionData.customer} size="md" title={t('Fill in the form')} langs={actionData.formDefinition.languages}>
                    <Paper sx={{ p: 3 }}>
                        <Typography variant="h2" sx={{ mb: 3 }}>{t('Fill in the form')}</Typography>
                        {actionData && actionData.formDefinition && (
                            <Form definition={actionData.formDefinition} onSubmit={onSubmit} />
                        )}
                    </Paper>
                </Layout >
            )
        )
    );
}

export default ButtonPage;
